import type { EnvironmentId } from "@cmmd-forge/contracts";
import type { ForgeRuntimeSurface } from "../../environments/runtimeSurface";
import { classifyEnvironmentId } from "../../environments/environmentIdClassification";

export type SidebarEnvironmentRole = "local" | "cloud" | "remote";

export interface ResolveSidebarEnvironmentRoleInput {
  readonly environmentId: EnvironmentId;
  readonly primaryEnvironmentId: EnvironmentId | null;
  readonly runtimeSurface: ForgeRuntimeSurface;
  readonly savedEnvironmentRegistry: Readonly<Record<string, unknown>>;
}

export function resolveSidebarEnvironmentRole(
  input: ResolveSidebarEnvironmentRoleInput,
): SidebarEnvironmentRole {
  const isPrimary =
    input.primaryEnvironmentId !== null && input.environmentId === input.primaryEnvironmentId;
  const isCloud = classifyEnvironmentId(input.environmentId).isCloud;
  const isSavedRemote = input.environmentId in input.savedEnvironmentRegistry;

  if (isCloud) {
    return "cloud";
  }

  if (input.runtimeSurface === "desktop-cloud") {
    if (isPrimary) return "cloud";
    return isSavedRemote ? "remote" : "local";
  }

  if (input.runtimeSurface === "cloud-official") {
    if (isPrimary) return "cloud";
    return isSavedRemote ? "remote" : "local";
  }

  if (isPrimary) {
    return "local";
  }

  return isSavedRemote ? "remote" : "local";
}
